import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

// API
import * as API from '../../../utils/api';

// Packages
import { Helmet } from 'react-helmet';
import { Elements } from 'react-stripe-elements';

// Components
import Header from '../../../components/Global/Header';
import AccountSettingsNav from '../../../components/UserPortal/AccountSettings/AccountSettingsNav';
import FormContainer from '../../../components/Global/FormContainer';
import CreditCardForm from '../../../components/Forms/CreditCardForm'
import FlashMessage from '../../../components/Global/FlashMessage';

class UpdatePaymentInfo extends Component {
  state = {
    submissionStatus: '',
    flashMessage: {
      type: '',
      message: '',
    },
    displayFlashMessage: false,
    taxRate: '0.0'
  }

  handleStripeSubmit = (response, address) => {
    this.setState(state => ({
      ...state,
      submissionStatus: 'submitting'
    }), () => this.handleStripeUpdate(response.token.id, this.state.taxRate, address))
  }

  handleStripeUpdate = (token, taxRate, address) => {
    const { user } = this.props;

    API.updateStripePayment(user, token, address, user.maintained_profiles[0].username, taxRate)
      .then(response => {
        if (response.success) {
          this.handleSuccessfulSubmit();
        } else if (response.errors) {
          this.handleErrorSubmit(response.errors);
        } else {
          this.handleErrorSubmit('An error occured. Please try again');
        }
      })
  }

  handleGetTaxRate = (zipCode) =>  {
    const { user } = this.props

    API.getTaxRate(user, zipCode).then(response => {
      if (response.errors || response.error) {
        this.setState({
          errorMessage: response.errors[0] ? response.errors[0] : 'Error getting tax rate. Please try again.'
        })
      } else {
        this.setState({
          taxRate: response.totalRate
        })
      }
    })
  }

    handleSuccessfulSubmit() {
    window.scrollTo(0, 0)
    this.setState({
      submissionStatus: '',
      flashMessage: {
        type: '',
        message: 'Your changes have been saved successfully.'
      },
      displayFlashMessage: true
    })
  }

  handleErrorSubmit(message) {
    window.scrollTo(0, 0)
    this.setState({
      submissionStatus: '',
      flashMessage: {
        type: 'error',
        message: message,
      },
      displayFlashMessage: true
    })
  }

  renderFlashMessage() {
    const {
      displayFlashMessage,
      flashMessage
    } = this.state;

    return displayFlashMessage
    ? (
      <FlashMessage optionalClasses={flashMessage.type === 'error' ? 'error' : ''}>
        {flashMessage.message}
      </FlashMessage>
    ) : null
  }

  render() {
    const { path, appName } = this.props;
    const { submissionStatus } = this.state;

    return (
      <div className="user-portal account-settings update-payment-info">
        <Helmet>
          <title>{appName} | Settings – Update Payment Info</title>
        </Helmet>
        <Header path={ path } />
        <AccountSettingsNav currentTab="payment-info" />
        <FormContainer>
          <header>
            <h1>Update Credit Card Info</h1>
          </header>
          {this.renderFlashMessage()}
          <Elements>
            <CreditCardForm
              submitText='Save Changes'
              handleFormSubmit={this.handleStripeSubmit}
              getTaxRate={this.handleGetTaxRate}
              status={submissionStatus}
              totalCharge={'1000000'}
            />
          </Elements>
          <Link
            to="/settings/payment-info/"
            className="cta full-width"
          >
            Cancel
          </Link>
        </FormContainer>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
  }
}

export default connect(
  mapStateToProps,
  null
)(UpdatePaymentInfo)



// WEBPACK FOOTER //
// ./src/screens/UserPortal/Settings/UpdatePaymentInfo.js